import styled from 'styled-components';
import { SxProps } from '@mui/material';
import { ReactComponent as SearchIcon } from '../../../assets/search.svg';
import { Flex } from '../../Flex';
import IncrementSelector from '../../IncrementSelector';
import WidgetButton from '../../WidgetButton';

type ChartZoomControlsProps = {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  disableZoomIn: boolean;
  disableZoomOut: boolean;
  disableReset: boolean;
  loading: boolean;
  vertical?: boolean;
  sx?: SxProps;
};

const ZoomIconWrapper = styled(Flex)`
  background: ${({ theme }) => theme.palette.common.white};
  height: 100%;
  width: 36px;
  justify-content: center;
  align-items: center;
`;

const ZoomIcon = styled(SearchIcon)`
  transform: scale(0.8);
  path {
    fill: ${({ theme }) => theme.palette.common.black};
  }
`;

const WidgetButtonStyled = styled(WidgetButton)`
  background: ${({ theme }) => theme.palette.common.gray5};
  color: ${({ theme }) => theme.palette.common.black};
  border: 1px solid ${({ theme }) => theme.palette.common.gray};
  min-width: 0;
  height: 24px;
  border-radius: 8px;

  :hover {
    border: 1px solid ${({ theme }) => theme.palette.common.gray};
    background: ${({ theme }) => theme.palette.common.gray14};
  }

  :disabled {
    background: ${({ theme }) => theme.palette.common.gray8};
    border: 1px solid ${({ theme }) => theme.palette.common.gray};
  }
`;

const IncrementSelectorStyled = styled(IncrementSelector)`
  width: 80px;
  border: 1px solid ${({ theme }) => theme.palette.common.gray};

  button {
    background: ${({ theme }) => theme.palette.common.gray5};

    :hover {
      background: ${({ theme }) => theme.palette.common.gray14};
    }
  }
`;

const ChartZoomControls = ({
  onZoomIn,
  onZoomOut,
  onReset,
  disableZoomIn,
  disableZoomOut,
  disableReset,
  loading,
  vertical,
  sx,
}: ChartZoomControlsProps) => (
  <Flex
    sx={{
      gap: 1,
      flexDirection: vertical ? 'column-reverse' : 'row',
      zIndex: 1,
      ...sx,
    }}
  >
    <WidgetButtonStyled
      variant="outlined"
      disabled={disableReset}
      onClick={onReset}
    >
      RESET
    </WidgetButtonStyled>

    <IncrementSelectorStyled
      onPlus={onZoomIn}
      onMinus={onZoomOut}
      disabled={loading}
      disablePlus={disableZoomIn}
      disableMinus={disableZoomOut}
      minusTooltip={disableZoomOut ? 'Minimum zoom level reached' : 'Zoom out'}
      plusTooltip={disableZoomIn ? 'Maximum zoom level reached' : 'Zoom in'}
    >
      <ZoomIconWrapper>
        <ZoomIcon />
      </ZoomIconWrapper>
    </IncrementSelectorStyled>
  </Flex>
);

export default ChartZoomControls;
